var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userLogin"},[(_vm.isLogin)?_c('div',{staticClass:"loginBtn displayNone logout",on:{"click":_vm.logout}},[_vm._v("退出登录")]):_vm._e(),_c('div',{staticClass:"loginBtn",on:{"click":_vm.gotoPersen}},[_vm._v("我的商城")])])}
var staticRenderFns = []

export { render, staticRenderFns }